import moment from "moment";

export const formatDateForMessages = (
  timestamp: string | Date | moment.Moment,
): string => {
  const timestampMoment = moment(timestamp);
  const nowMoment = moment();

  if (timestampMoment.isSame(nowMoment, "day")) {
    return timestampMoment.format("h:mm A");
  } else {
    return timestampMoment.format("M/D/YY, h:mm A");
  }
};

export const formatDateShort = (
  timestamp: string | Date | moment.Moment,
): string => {
  const timestampMoment = moment(timestamp);
  return timestampMoment.format("MMM DD, YYYY");
};
